import React, {useEffect} from 'react';

import {hooks} from '../../hooks';
import {Screens} from '../../enums';
import {components} from '../../components';
import {actions} from '../../store/actions';
import {salon, salonServices} from '../../config/salon';

export const Home: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#FFF7F4');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#FFF7F4'));
  }, [dispatch]);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showLogo={true}
        showBasket={true}
        headerStyle={{
          backgroundColor: 'var(--main-background)',
        }}
      />
    );
  };

  const renderServices = (): JSX.Element => {
    return (
      <section className='salon-section'>
        <div className='salon-section__header'>
          <div>
            <span className='salon-eyebrow'>Menü</span>
            <h2>Popüler Hizmetler</h2>
            <p className='salon-section__text'>
              Bakım, güzellik ve estetik görünüm odaklı uygulamalar.
            </p>
          </div>
          <button
            className='salon-button salon-button--outline'
            onClick={() => dispatch(actions.setScreen(Screens.Search))}
            type='button'
          >
            Tümünü Gör
          </button>
        </div>
        <components.ServiceGrid
          services={salonServices.slice(0, 6)}
          galleryServices={salonServices}
        />
      </section>
    );
  };

  const renderContact = (): JSX.Element => {
    return (
      <section className='salon-section'>
        <div className='salon-section__header'>
          <div>
            <span className='salon-eyebrow'>İletişim</span>
            <h2>Randevu ve Konum</h2>
            <p className='salon-section__text'>
              Hızlı randevu için arayın, WhatsApp'tan yazın veya konuma göz
              atın.
            </p>
          </div>
        </div>
        <div className='salon-info-grid'>
          <article className='salon-contact-card'>
            <h3>Telefon</h3>
            <p>
              <a href={salon.phoneHref}>{salon.phone}</a>
            </p>
          </article>
          <article className='salon-contact-card'>
            <h3>Instagram</h3>
            <p>
              <a
                href={salon.instagramHref}
                target='_blank'
                rel='noreferrer'
              >
                {salon.instagramHandle}
              </a>
            </p>
          </article>
          <article className='salon-contact-card'>
            <h3>Adres</h3>
            <p>
              <a
                href={salon.mapsHref}
                target='_blank'
                rel='noreferrer'
              >
                {salon.address}
              </a>
            </p>
          </article>
        </div>
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable salon-main'>
        <components.HeroSlider />
        {renderServices()}
        {renderContact()}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      <components.QuickContact />
      <components.Footer />
    </>
  );
};
